import { Service } from '@/types/ServicePackage'
import Answer from './Answer'
import Tier from './Tier'

export default class Selection {
  answer: Answer;
  tier?: Tier;

  constructor (answer: Answer, tier?: Tier) {
    this.answer = answer
    this.tier = tier
  }

  get retailPrice (): number | undefined {
    return this.tier?.retailPrice ?? this.answer.retailPrice
  }

  get procedureCode (): string | undefined {
    return this.tier?.procedureCode || this.answer.procedureCode
  }

  get name (): string {
    return this.tier ? this.tier.name : this.answer.name
  }

  get eventName (): string {
    return 'event-' + this.name
      .toLowerCase()
      .replace(/[-\s]+/g, '-')
      .replace(/[()]/g, '')
  }

  get service (): Service | undefined {
    if (this.procedureCode && this.retailPrice !== undefined) {
      return {
        procedureCode: this.procedureCode,
        charges: this.retailPrice
      }
    }

    return undefined
  }

  toString (): string {
    return `${this.answer.heading}${this.tier ? ` (${this.tier?.heading})` : ''}`
  }
}
